import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useState } from 'react';
import Banner from '../components/Banner';
import { useAuthContext } from '../context/authContext';
import AuthDecoration from '../images/auth-decoration.png';
import AuthImage from '../images/Slide01.webp';

import { useSearchParams } from 'react-router-dom';
import { handleClick } from '../components/Utils';
import AuthPages from '../components/AuthPages';
import TemplatePage from './TemplatePage';

function Signin() {
    const { t } = useTranslation();
    const auth = useAuthContext();

    const [searchParams, setSearchParams] = useSearchParams();
    const [url, setUrl] = useState(searchParams.get('originUrl'))

    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");


    const [disableButton, setDisableButton] = useState(false);

    const [errorMessage, setErrorMessage] = useState({
        type: '',
        message: '',
        open: false,
    });

    const cleanMessage = () => {
        setErrorMessage({ ...errorMessage, type: "", message: "", open: false });

    }

    const setOpen = (value) => {
        setErrorMessage({ ...errorMessage, open: value });
    }

    const login = (event) => {
        event.preventDefault();
        setDisableButton(true);

        if (username === "" || password === "") {
            setErrorMessage({ ...errorMessage, type: "warning", message: t("auth.noData"), open: true });
            setDisableButton(false);
            return;
        }
        fetch(`${process.env.REACT_APP_LOGIN}`, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                // Authorization: `Bearer ${UserService.getToken()}`,
            },
            body: JSON.stringify({ username: username, password: password })
        })
            .then(j => j.json())
            .then(r => {
                const token = r.access_token;
                const refreshToken = r.refresh_token;
                setDisableButton(false);
                if (token === undefined) {
                    const error = r.message;
                    if (error === "HTTP 401 Unauthorized") {
                        setErrorMessage({ ...errorMessage, type: "error", message: t("auth.invalidCredentials"), open: true });
                    } else if (error === "HTTP 400 Bad Request") {
                        setErrorMessage({ ...errorMessage, type: "error", message: t("auth.noFullySetUp"), open: true });
                    } else {
                        setErrorMessage({ ...errorMessage, type: "error", message: t("auth.error"), open: true });
                    }
                    return;
                }

                auth.setLogin(token, refreshToken, url);
            }
            ).catch(error => {
                setErrorMessage({ ...errorMessage, type: "error", message: t("auth.error"), open: true });
                setDisableButton(false)

            });

    }


    return (
        <TemplatePage
            h1={t("meta.login.title")}
            title={t("meta.login.title")}
            desc={t("meta.login.description")}
            image={AuthImage}>

            <AuthPages image={AuthImage} decoration={AuthDecoration} >
                <h2 className="text-3xl text-airco2-general font-bold mb-6">{t("auth.titleLogin")} ✨</h2>


                <Banner type={errorMessage.type} children={errorMessage.message} open={errorMessage.open} setOpen={setOpen} className="mb-3 w-ful"></Banner>


                {/* Form */}
                <form onSubmit={login}>
                    <div className="space-y-4 text-airco2-general">
                        <div>
                            <label className="block text-sm font-medium mb-1" htmlFor="email">{t("auth.email")}</label>
                            <input id="email" className="form-user-data w-full bg-white" type="email" onChange={(e) => { cleanMessage(); setUserName(e.target.value) }} />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1" htmlFor="password">{t("auth.password")}</label>
                            <input id="password" className="form-user-data w-full bg-white" type="password" autoComplete="on"
                                onChange={(e) => { cleanMessage(); setPassword(e.target.value) }}
                                onKeyDown={e => e.key === 'Enter' ? login(e) : ''}
                            />
                        </div>
                    </div>
                    <div className=" mt-6 ">


                        <button className="btn bg-airco2-principal text-white  whitespace-nowrap w-full" type="submit" disabled={disableButton}>
                            {disableButton ? <svg role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                            </svg> : t("auth.login")}
                        </button>
                    </div>
                    <div className=" mt-2  ">
                        <div className="mr-1 text-center w-full">
                            <Link onClick={handleClick} className="text-xs underline text-airco2-general hover:no-underline" to="/reset-password">{t("auth.passwordForgot")}</Link>
                        </div>
                    </div>

                </form>
                {/* Footer */}
                <div className="pt-5 mt-6 border-t border-gray-200 text-center">
                    <div className="text-sm text-airco2-filter-content">
                        {t("auth.account")} <Link onClick={handleClick} className="font-medium text-airco2-secondary hover:text-blue-600" to="/register" >{t("auth.signup")}</Link>
                    </div>

                </div>
            </AuthPages>
        </TemplatePage>

    );
}

export default Signin;